import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { BASE_URL } from '../../../constant/index';
import { useAuth } from "../../../context/AuthProvider";
import AddNotification from "./AddNotification";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
}));

const Notifications = () => {
    const { token, userEmail } = useAuth();
    const [ notifications, setNotifications ] = useState([]);
    const [ isLoading, setLoading ] = useState(false);
	const [ errorMsg, setErrorMsg ] = useState('');
    const [ successMsg, setSuccessMsg ] = useState('');
    const [ selectedNotification, setSelectedNotification ] = useState(null);
    const [ openAddNotificationModal, setAddNotificationModalOpen ] = useState(false);
    const columns = [
        { field: 'title', headerName: 'Title', width: 500 },
        { field: 'status', headerName: 'Status', width: 200 },
    ];

    const handleAdd = () => {
        setAddNotificationModalOpen(true);
    }

    const handleCompleteNotification = async () => {
        if(!selectedNotification) {
            setErrorMsg("Please select any one from the below rows to update!");
            return;
        }
        try {
            setLoading(true);
            const { data } = await axios.post(BASE_URL+'/updateNotificationToComplete', { id: selectedNotification.id }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            if(data?.msg) {
                setSuccessMsg(data.msg);
                getNotifications();
            }
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
        } finally {
            setLoading(false);
            setSelectedNotification('');
        }
    }

    const handleEvent = (event) => {
        setSelectedNotification(event.row);
    }

    const getNotifications = async () => {
        setLoading(true);
		try {
            const { data } = await axios.post(BASE_URL+'/getNotifications', {}, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });
            setNotifications(data?.allNotifications || []);
            setLoading(false);
        } catch(err) {
            const errMsg = err?.response?.data?.msg;
            setErrorMsg(errMsg || 'Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
		}  
    }

    useEffect(() => {
        getNotifications();
    }, []);

    return (
        <>
            <Stack
                direction="row"
                spacing={2}
            >
                <Item>
                    <Stack direction="row" spacing={2} sx={{ justifyContent: "flex-end", alignItems: "center"}}>
                        <Button onClick={handleAdd} variant="outlined">Add Notification</Button>
                        <Button onClick={handleCompleteNotification} variant="outlined">Mark as closed</Button>
                    </Stack>
                </Item>
            </Stack>
            <div className="max-w-6xl mx-auto p-6">
                <div className="col-6">
                    <div style={{ height: 450, width: '100%', marginTop: '10px' }}>
                        <DataGrid
                            disableColumnFilter
                            disableColumnSelector
                            disableDensitySelector
                            disableColumnMenu
                            rows={notifications || []}
                            onRowClick={handleEvent}
                            editMode="row"
                            columns={columns}
                            pageSizeOptions={[5, 50, 100]}
                            localeText={{ noRowsLabel: "No notifications found" }}
                            hideFooterSelectedRowCount={true}
                        />
                    </div>
                </div>
            </div>
            {
                openAddNotificationModal && (
                    <AddNotification 
                        openAddNotificationModal={openAddNotificationModal}
                        setAddNotificationModalOpen={setAddNotificationModalOpen}
                        setSuccessMsg={setSuccessMsg}
                        setErrorMsg={setErrorMsg}
                        setLoading={setLoading}
                        isLoading={isLoading}
                    />
                )
            }
        </>
    )
}

export default Notifications;